function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1",
  "data-name": "Path 1",
  d: "M961.828,52a8.829,8.829,0,0,1-2.546.726,4.849,4.849,0,0,0,1.94-2.423,11.126,11.126,0,0,1-2.788,1.091,4.145,4.145,0,0,0-5.845-.443c-.074.063-.146.13-.215.2a4.383,4.383,0,0,0-1.213,4.117,12.25,12.25,0,0,1-9.089-4.487,4.186,4.186,0,0,0-.6,2.182,4.434,4.434,0,0,0,1.938,3.636,6.017,6.017,0,0,1-1.94-.6h0a4.292,4.292,0,0,0,3.515,4.243,3.536,3.536,0,0,1-1.94.121,4.257,4.257,0,0,0,4,3.031,8.7,8.7,0,0,1-5.455,1.817,3.388,3.388,0,0,1-1.091-.121,11.614,11.614,0,0,0,6.67,1.936,12.3,12.3,0,0,0,12.366-12.231v-.73a6.316,6.316,0,0,0,2.3-2.06",
  transform: "translate(-940.497 -49.952)",
  fill: "#3352cb"
});

var SvgTwitterIcon = function SvgTwitterIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 21.338,
    height: 17.074,
    viewBox: "0 0 21.338 17.074",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTwitterIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter-icon.f0f34f62.svg";
export { ForwardRef as ReactComponent };